import { BaseField, BaseFieldModel } from '../baseField';
import { FieldType } from '../fieldType';
import { CultureTextModel } from '../form';

export type AllowedDocumentTypes = 'pdf' | 'doc' | 'docx' | 'xlsx' | 'xls';

export interface DocumentViewerFieldModel extends BaseFieldModel {
  defaultValue: CultureTextModel[] | string;
  documentType: AllowedDocumentTypes;
  documentName: CultureTextModel[] | string;
  type: FieldType.DocumentViewer;
}

export class DocumentViewerField extends BaseField implements DocumentViewerFieldModel {
  public defaultValue: CultureTextModel[] | string = '';
  public documentType: AllowedDocumentTypes = 'pdf';
  public documentName: CultureTextModel[] | string = 'download';
  public type: FieldType.DocumentViewer = FieldType.DocumentViewer;

  constructor(cultures: string[]) {
    super(FieldType.DocumentViewer, cultures);

    this.defaultValue = [];
    this.documentName = [];
    for (const culture of cultures) {
      this.defaultValue.push({ culture, value: '' });
      this.documentName.push({ culture, value: 'download' });
    }
  }
}
